import api from './api.service';

type ApiBody<T> = { success?: boolean; data?: T; message?: string };

async function unwrap<T>(promise: Promise<unknown>): Promise<T> {
  const body = (await promise) as ApiBody<T>;
  if (body?.data === undefined) {
    throw new Error(body?.message || 'Digital Twin request failed');
  }
  return body.data;
}

export const digitalTwinService = {
  getDashboard: () => unwrap<Record<string, unknown>>(api.get('/digital-twin/dashboard')),
  getCatalog: () => unwrap<Array<Record<string, unknown>>>(api.get('/digital-twin/catalog')),
  getHistory: () => unwrap<unknown[]>(api.get('/digital-twin/history')),
  listSnapshots: () => unwrap<unknown[]>(api.get('/digital-twin/snapshots')),
  createSnapshot: (label?: string) =>
    unwrap<unknown>(api.post('/digital-twin/snapshots', { label })),
  listSimulations: () => unwrap<unknown[]>(api.get('/digital-twin/simulations')),
  getSimulation: (id: string) => unwrap<Record<string, unknown>>(api.get(`/digital-twin/simulations/${id}`)),
  runSimulation: (payload: {
    scenarioType: string;
    title?: string;
    params?: Record<string, unknown>;
    snapshotId?: string;
  }) => unwrap<Record<string, unknown>>(api.post('/digital-twin/simulations', payload)),
  compare: (simulationIds: string[], title?: string) =>
    unwrap<Record<string, unknown>>(api.post('/digital-twin/compare', { simulationIds, title })),
  forecast: (payload: { horizonDays: number; simulationId?: string }) =>
    unwrap<Record<string, unknown>>(api.post('/digital-twin/forecast', payload)),
  promote: (simulationId: string, confirm = true) =>
    unwrap<unknown>(api.post('/digital-twin/promote-to-actions', { simulationId, confirm })),
  archive: (id: string) => unwrap<unknown>(api.post(`/digital-twin/simulations/${id}/archive`, {})),
};
